export enum ActionType {
  CHANGE_THEME = "change_theme",
  FAVORITE_USER = "favorite_user",
}
